import Title from '../components/title';
import Footer from '../components/footer';
import Subtitle from '../components/subtitle';
import Core from '../components/core';

import { ArrowLongDownIcon } from '@heroicons/react/20/solid'
import {  ScrollRestoration } from "react-router-dom"

const navigation = [
    { id: 1, name: 'Nos recommandations', to: '/strategie-retraite/' , icon: ArrowLongDownIcon},
    { id: 3, name: 'Articulation chômage / retraite', to: '/articulation-chomage-retraite/' , icon: ArrowLongDownIcon},
    { id: 4, name: 'Des solutions d\'optimisation', to: '/solutions-optimisation/' , icon: ArrowLongDownIcon},
    { id: 5, name: 'Etudes comparatives expatriation', to: '/retour-expatriation/' , icon: ArrowLongDownIcon},
    { id: 6, name: 'Des conférences spécifiques', to: '/nos-conferences/' , icon: ArrowLongDownIcon},
    { id: 7, name: 'Liquidations de retraite', to: '/liquidations-retraite/' , icon: ArrowLongDownIcon},
]

const context = [
    {
        "title": <p className='text-lg leading-6 text-gray-600'>Bénéficiez d'une analyse approfondie et d'un accompagnement individualisé pour :</p>,
        "core": [
            {
                "subtitle": "",
                "text": ""
            }
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900">Evaluer votre situation retraite :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> Nous prenons en compte tous les éléments de votre parcours professionnel, en France et à l\'étranger, dans le privé comme dans le public, pour vous offrir une évaluation précise et fiable de vos droits à la retraite. </span>,
            },            
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Validation de trimestres :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> Nos experts étudient les différentes options d\'optimisation de vos droits à la retraite, tels que le rachat de trimestres, et vous proposent des schémas personnalisés cohérents avec vos objectifs. </span>,
            },            
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Obtenir des projections claires :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> Nous réalisons des projections détaillées de vos droits à la retraite jusqu'à la liquidation, en tenant compte des hypothèses définies ensemble lors de nos échanges. Ces hypothèses peuvent concerner un changement de rémunération, de statut professionnel, de départ à l'étranger... </span>,
            },            
        ]
    },
    {
        "title": <p className='text-lg leading-6 text-gray-600'> Notre service d'évaluation retraite s'inscrit également dans le cadre du maintien des seniors dans l'emploi dans la mesure où la recherche du taux plein est indispensable.</p>,
        "core": [
            {
                "subtitle": "",
                "text": ""
            }
        ]
    },
]

export default function Bilan() {
   

    return (
        <>

            <Title classNames="bg-bilan bg-cover lg:bg-right bg-left" title="Bilans retraite" />

            <Subtitle subtitle="Service personnalisé d'évaluation de la situation retraite" paragraph="Qui s'adapte à tous types de parcours professionnels" />      

            <Core navigation={navigation} context={context} />

            <Footer />

            <ScrollRestoration />
        </>
    )
}